import {weaponImageName} from "../utils";

export const BASE_URL = 'https://xdloadout.pro/'
export const API_URL = BASE_URL + "api/"
export const getMetaLoadouts = (weapon, category) =>
    fetch(`${API_URL}loadouts?collection=meta&category=${category}&weapon=${weaponImageName(weapon)}`)
        .then(response => {
            if (response.ok) return response.json()
            throw new Error(`Response status was ${response.status}`)
        })